export default __webpack_public_path__ + "static/media/apple-MagicMouse.77a0522b.jpg";